import { Navigate } from 'react-router-dom';

const decodeJwtPayload = (jwt) => {
  try {
    const payload = jwt.split('.')[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4 || 4)), '=');
    const bytes = Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
    const json = new TextDecoder().decode(bytes);
    return JSON.parse(json);
  } catch (err) {
    return null;
  }
};

const isTokenExpired = (jwt, skewSeconds = 30) => {
  const payload = decodeJwtPayload(jwt);
  if (!payload?.exp) {
    return true;
  }
  const nowInSeconds = Math.floor(Date.now() / 1000);
  return payload.exp <= nowInSeconds + skewSeconds;
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token || isTokenExpired(token)) {
    if (token) {
      localStorage.removeItem('token');
    }
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;

